import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client';
import { AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_DEV, AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_PROD } from '../constants';
import * as Logger from './logger';
import * as amplitude from '@amplitude/experiment-js-client';
import { isDevelopmentEnvironment } from '@/helpers';

export enum FeatureFlag {
    TestFlag = 'test-flag',
    WorkflowsOverview = 'workflows-overview',
}

export enum FeatureFlagVariantValue {
    On = 'on',
}

export const initializeAmplitudeExperimentClient: (isDevEnv: boolean) => ExperimentClient = (isDevEnv) => {
    const experimentDeploymentKey =
        isDevEnv ? AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_DEV : AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_PROD;

    return Experiment.initializeWithAmplitudeAnalytics(experimentDeploymentKey);
};

export type ExperimentUser = amplitude.ExperimentUser;

export const startAmplitudeExperimentClient: (experimentUser: ExperimentUser, isDevEnv?: boolean) => void = (
    experimentUser,
    isDevEnv = isDevelopmentEnvironment(),
) => {
    const experimentClient = initializeAmplitudeExperimentClient(isDevEnv);

    experimentClient
        .start(experimentUser) //  used for immediate evaluation based on user props that can change
        .then(() => {
            if (isDevEnv) {
                Logger.log('Amplitude experiment successfully SDK started');
            }
        })
        .catch((error) => {
            if (isDevEnv) {
                Logger.log('Amplitude experiment failed to start with error: ' + error);
            }
        });
};

// Warning - ONLY call this *after* "startAmplitudeExperimentClient" has been called - ie. after the user has signed in
// Return value can be null, indicating the user hasn't been bucketed into a treatment and we should fall back to the control value
export const getValueForFlag: (flag: FeatureFlag, isDevEnv?: boolean) => string = (
    flag,
    isDevEnv = isDevelopmentEnvironment(),
) => {
    const experimentClient = initializeAmplitudeExperimentClient(isDevEnv);

    const value = experimentClient.variant(flag).value;

    if (isDevEnv) {
        Logger.log(`Feature flag ${flag} is ${value}`);
    }

    return value;
};
